import request from "@/utils/request";

export function queryPageList (data){
  return request({
    url:'/osp/material/queryPageList',
    method:'post',
    data: data
  })
}
export function queryByKey (data){
  return request({
    url:'/osp/material/queryByKey',
    method:'post',
    data: data
  })
}

export function queryPageListByFilter (data){
  return request({
    url:'/osp/material/queryPageListByFilter',
    method:'post',
    data: data
  })
}

export function queryPageListByAll (data){
  return request({
    url:'/osp/material/queryPageListByAll',
    method:'post',
    data: data
  })
}

export function queryScreenPageList (data){
  return request({
    url:'/osp/material/queryScreenPageList',
    method:'post',
    data: data
  })
}



export function queryGoodDetailById (data){
  return request({
    url:'/osp/material/queryDetailById?material_id=' + data,
    method:'post',
  })
}

export function saveBo (data){
  return request({
    url:'/osp/material/saveBo',
    method:'post',
    data: data
  })
}

export function updateBo (data){
  return request({
    url:'/osp/material/updateByBo',
    method:'post',
    data: data
  })
}

export function getMaterialGroupList(data){
  return request({
    url:'/osp/material/getMaterialGroupList',
    method:'post',
    data: data
  })
}

export function getMaterialLogoList(data){
  return request({
    url:'/osp/material/getMaterialLogoList',
    method:'post',
    data: data
  })
}

export function getMaterialModelList(data){
  return request({
    url:'/osp/material/getMaterialModelList',
    method:'post',
    data: data
  })
}
